import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, ValidationErrors } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-location-stock-input',
  templateUrl: './location-stock-input.component.html',
  styleUrls: ['./location-stock-input.component.scss']
})
export class LocationStockInputComponent implements OnInit, OnDestroy {
  @Input() tagsArray!: FormArray<FormControl<string>>;
  @Input() placeholder: string = 'Add tag...';
  @Input() allowDuplicates: boolean = false;
  @Input() maxTags?: number;
  @Input() label?: string;
  @Input() error: boolean = false;
  @Input() errorMessage?: string;

  @Output() tagsChange = new EventEmitter<string[]>();

  inputControl = new FormControl('');

  private destroy$ = new Subject<void>();

  touched = false;
  disabled = false;

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    if (!this.tagsArray) {
      throw new Error('tagsArray Input is required for TagInputComponent');
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  addTag(): void {
    this.touched = true;

    const tagValue = this.inputControl.value?.trim();

    if (!tagValue) {
      return;
    }

    // Check for duplicates
    if (!this.allowDuplicates && this.tagsArray.value.includes(tagValue)) {
      this.inputControl.setValue('');
      return;
    }

    // Check max tags limit
    if (this.maxTags && this.tagsArray.length >= this.maxTags) {
      return;
    }

    this.tagsArray.push(this.fb.control(tagValue, { nonNullable: true }));
    // this.tage.emit(tagValue);
    this.inputControl.setValue('');
  }

  removeTag(index: number): void {
    this.touched = true;
    const removedValue = this.tagsArray.at(index).value;
    this.tagsArray.removeAt(index);
    // this.tagRemoved.emit({ index, value: removedValue });
  }

  onInputBlur(): void {
    if (!this.touched) {
      this.touched = true;
    }
  }


  get tags(): string[] {
    return this.tagsArray.value;
  }

  get hasInput(): boolean {
    return !!this.inputControl.value?.trim();
  }

  get isDisabled(): boolean {
    return this.tagsArray.disabled;
  }

  get showError(): boolean {
    return this.touched &&
      this.tagsArray.invalid &&
      !!this.errorMessage;
  }
}